import { useSelector } from "react-redux";

function HeaderCard({ handleLevelChange, levelSet, activeLevel }) {
  const contentValue = useSelector((state) => state.contents.contentValues);
  return (
    <div
      className="flex flex-col lg:flex-row gap-3 md:gap-4 max-w-8xl
       bg-yellow-500 w-full rounded-xl justify-between items-center px-2 py-3 lg:px-6 "
    >
      <div className="w-full md:w-auto flex flex-col">
        <h1
          className="text-xl md:text-2xl font-semibold
          text-white text-center md:text-left"
        >
          {contentValue?.["Unit"]?.toUpperCase()} {contentValue?.title}
        </h1>
        <hr className="bg-purple-600 h-0.5 border-none" />
        <p className="text-sm font-medium text-white text-center">
          {contentValue?.description}
        </p>
      </div>

      <div className="flex justify-center gap-2 sm:gap-6 md:gap-8 w-full md:w-auto">
        {levelSet.map((level) => {
          const isExit = level.name === "Exit" || level.name === "Exıt";
          const isActive = activeLevel === level.name;

          return (
            <button
              key={level.name}
              onClick={() => handleLevelChange(level.name)}
              className={`px-2 py-2 md:px-4 text-sm md:text-base  
                font-semibold transition-all rounded-lg group
                ${
                  isExit
                    ? // 🔴 Exit butonu (kırmızı)
                      isActive
                      ? "bg-red-600 text-white shadow-md"
                      : "text-red-500  hover:bg-red-600 hover:text-white"
                    : // 🟣 Diğer butonlar
                      isActive
                      ? "bg-purple-500 text-white shadow-md"
                      : "text-white hover:bg-purple-500"
                }`}
            >
              <p>{level.name}</p>
              <hr
                className={`border-b-2 transition-colors ${
                  isExit
                    ? isActive
                      ? "border-red-400"
                      : "border-red-500 group-hover:border-red-400"
                    : isActive
                      ? "border-yellow-500"
                      : "border-purple-500 group-hover:border-yellow-500"
                }`}
              />
              <p className="text-sm font-medium">{level.tr}</p>
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default HeaderCard;
